import { create } from 'zustand';

interface IsAppState {
  isFromOldApp: boolean;
  setIsFromOldApp: (value: boolean) => void;
}

export const useIsAppStore = create<IsAppState>((set) => ({
	isFromOldApp: false,
	setIsFromOldApp: (value) => set({ isFromOldApp: value }),
})); 